import React, { FC } from 'react';
import { OrderProduct } from '../../interfaces/Assets';
import ListComponent from '../../utils/ListComponent';
import LoadingSpinner from '../buttons/LoadingSpinner';
import Table from './Table';
import TableItem from './TableItem';
import TableRow from './TableRow';

interface props {
  assets: OrderProduct[];
  onclick: (id: number) => Promise<void>;
  loading: boolean;
}

const SelectAssetTable: FC<props> = ({ assets, onclick, loading }) => {
  const tableHeaders: object = ['Name', 'Serial'];

  if (loading && assets.length === 0) {
    return <LoadingSpinner />;
  }

  if (!Array.isArray(assets) || assets.length === 0) {
    return null;
  }

  return (
    <Table header={tableHeaders}>
      {loading ? (
        <TableRow>
          <TableItem>
            <LoadingSpinner />
          </TableItem>
        </TableRow>
      ) : (
        ''
      )}
      <ListComponent
        data={assets}
        renderItem={(item) => (
          <TableRow
            key={item.ordSer_id}
            onClick={() => {
              onclick(item.ordSer_id);
            }}
          >
            <TableItem>{item.ordPro_naam}</TableItem>
            <TableItem>{item.ordSer_serial}</TableItem>
          </TableRow>
        )}
      />
    </Table>
  );
};

export default SelectAssetTable;
